import { 
	FeatureSlideFactory, 
	FeatureSlide 
} from './featureHighlightSlides';


export function createSlides(sbaFeatureSlideFactory:FeatureSlideFactory, gettextCatalog:ng.gettext.gettextCatalog):FeatureSlide[]{
	return [
		sbaFeatureSlideFactory.createImage({
			link: 'http://sharebase.com/featurefeed/tasks',
			title: gettextCatalog.getString('ShareBase Tasks'),
			text: gettextCatalog.getString('Assign a task on a document to anyone who needs to make an ‘approve or deny’ decision. Click the image to learn more.')
		},
		'Tasks-Animation.gif',
		'Platform/Tasks'
		),
		sbaFeatureSlideFactory.createImage({
			title: gettextCatalog.getString('Toolbar Update'),
			text: gettextCatalog.getString('The toolbar has slimmed down. Share by User and Create Link actions are grouped under a new Share icon. Download and Upload remain on the main toolbar, while less commonly used actions are available under the More Actions icon.')
		},
		'ToolBarSplashScreen.gif',
		'minimized-action-bar'
		),
		sbaFeatureSlideFactory.createLinkToVideo({
			link: 'https://sharebase.com/featurefeed/email_digest',
			title: gettextCatalog.getString('Email Digest'),
			text: gettextCatalog.getString('Never miss important ShareBase notifications again. Email Digest provides you an email summary of all new notifications for activities that occurred since the last digest. Get notified on an hourly, daily or weekly basis. Click the video to learn how to setup your digest.')
		},
		'EmailDigestSplashScreen.gif',
		'Core/EmailDigest'
		),
		sbaFeatureSlideFactory.createLinkToVideo({
			link: 'https://sharebase.com/featurefeed/search',
			title: gettextCatalog.getString('Search'),
			text: gettextCatalog.getString('Never again have problems finding your content thanks to ShareBase Search! Quickly and easily find your files, shared files and files stored in corporate libraries. You can search content based on file name, text within a file, file type and the file creator. Click on the video to learn more!')
		},
		'ShareBaseSearchSplash.gif',
		'Core/Full-Text-Search'
		),
		sbaFeatureSlideFactory.createLinkToVideoRestricted({
			link: 'https://sharebase.com/featurefeed/administrative_reporting',
			title: gettextCatalog.getString('Administrative Reporting'),
			text: gettextCatalog.getString('With the new Administrative Reporting capabilities, you can gain insight into your user\'s activity, what documents they are sharing via links and get basic user information all in one place. Click on the video to learn more!')
		},
		'AdminReportingSplash.gif',
		['Admin'],
		'admin-reports'
		)
	];
}

createSlides.$inject = [
	'sbaFeatureSlideFactory',
	'gettextCatalog'
];



// WEBPACK FOOTER //
// ./src/sharebase-app/components/slides/featureHighlightSlides/feature-slides.ts